import React, { useEffect, useState } from "react";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import ServiceAdvisoryList from "./ServiceAdvisoryList";
import { useParams, useLocation, useHistory } from "react-router-dom";
import {
  brandListingOnSelectedBrickService,
  brickListingOnSelectedBrandService,
  CategoryListOnSelectedBrandService,
} from "../../services/ModelViewService";
import {
  BrickListingWithOrWithoutFamilyId,
  FamilyListingService,
  AllBrandListingService,
} from "../../services/MasterDataManagementService";
import {
  ServiceAdvisoryListOnSearchService,
  ServiceAdvisoryListService,
  ServiceAdvisoryUploadService,
  ServiceAdvisoryUpdatService,
  ModelListingService,
  ModelDescriptionOnSelectedModelService,
  ModeDeptListingService,
  LoadAdvServiceFiles,
  DownloadServiceAdvisoryService,
} from "../../services/ServiceAdvisoryService";
import useGlobalState from "../../Context";
import {
  docTypeListingService,
  getAllDropDownService,
  getAllDropDownListService,
} from "../../services/TechnicalDocumentService";
import { departmentsListingService } from "../../services/UserOnboardingService";
import JSZip from "jszip";
import download from "downloadjs";

const ServiceAdvisory = () => {
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [techDocumentRecords, setTechDocumentRecords] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [brandListOnBrickId, setBrandListOnBrickId] = useState([]);
  const [brickListOnBrandId, setBrickListOnBrandId] = useState([]);
  const [allBrands, setAllBrands] = useState([]);
  const [modelList, setModelList] = useState([]);
  const [modelDescription, setModelDescription] = useState();
  const [notificationDetailState, setNotificationDetailState] = useState(false);
  const [notificationPageNo, setNotificationPageNo] = useState();
  const [notificationType, setNotificationType] = useState();
  const [brickListForUpload, setBrickListForUpload] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const { state } = useLocation();
  const history = useLocation();
  const [{ auth }, dispatch] = useGlobalState();
  const [brickList, setBrickList] = useState([]);
  const loginUserId = auth.ldapParam.userId;
  const id = useParams();
  const [productFamilyList, setProductFamilyList] = useState([]);
  const [categoryListOnBrandId, setCategoryListOnBrandId] = useState([]);
  const [docTypeList, setDocTypeListing] = useState([]);
  const [departmentList, setDepartMentList] = useState([]);
  const [brandDropDownList, setBrandDropDownList] = useState([]);
  const loginUserType = auth.ldapParam.userType;
  const [familyList, setFamilyList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [brickDropdownList, setBrickDropDownList] = useState([]);
  const [modelIdData, setModelIdData] = useState([]);
  const [deptIdData, setDeptIdData] = useState([]);
  const [selectedModelIds, setSelectedModelIds] = useState([]);
  const [selectedDeptIds, setSelectedDeptlIds] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  useEffect(() => {
    if (history.pathname == "/service-advisory-view") {
      if (state) {
        setTechDocumentRecords(state?.content?.data);
        setTotalElements(state?.content?.data?.length);
        setNotificationDetailState(true);
        setNotificationType(state?.["typeId"]);
        setNotificationPageNo(state["pageNo"]);
      } else {
        setTechDocumentRecords([]);
        setTotalElements(0);
      }
    } else {
      fetchServiceAdvisoryDetails("advisoryNumber", true);
      // fetchBrandListOnSelectedBrick();
      // fetchBrickListOnSelectedBrand();
      fetchDocTypeList();
      fetchDepartmentsList();
     // fetchCatSearchDropdownList();
     // fetchBrandSearchDropdownList();
     // fetchFamSearchDropdownList();
     // fetchBrickSearchDropdownList();
     // fetchBrandSearchDropdownList();
     fetchAllDropDownList();
    }
  }, [state]);

  const fetchAllDropDownList = async () => {
    try {
      const response = await getAllDropDownListService();
     
      if (response.statusCode === 6) {
   
        setFamilyList(response.data.family);
        setBrandDropDownList(response.data.brand);
        setCategoryList(response.data.category);
        setBrickDropDownList(response.data.brick);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
 
    }
  };
  const fetchBrandSearchDropdownList = async (
    brandId,
    brickId,
    productFamilyId,
    categoryId
  ) => {
    try {
      const response = await getAllDropDownService(
        brandId,
        brickId,
        productFamilyId,
        categoryId,
        4
      );
      if (response.statusCode === 6) {
        setBrandDropDownList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchFamSearchDropdownList = async (
    brandId,
    brickId,
    productFamilyId,
    categoryId
  ) => {
    try {
      const response = await getAllDropDownService(
        brandId,
        brickId,
        productFamilyId,
        categoryId,
        2
      );
      if (response.statusCode === 6) {
        setFamilyList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchCatSearchDropdownList = async (
    brandId,
    brickId,
    productFamilyId,
    categoryId
  ) => {
    try {
      const response = await getAllDropDownService(
        brandId,
        brickId,
        productFamilyId,
        categoryId,
        1
      );
      if (response.statusCode === 6) {
        setCategoryList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchBrickSearchDropdownList = async (
    brandId,
    brickId,
    productFamilyId,
    categoryId
  ) => {
    try {
      const response = await getAllDropDownService(
        brandId,
        brickId,
        productFamilyId,
        categoryId,
        3
      );
      if (response.statusCode === 6) {
        setBrickDropDownList(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchCategoryListOnSelectedBrand = async (id) => {
    try {
      const response = await CategoryListOnSelectedBrandService(id);
      if (response.statusCode === 6) {
        setCategoryListOnBrandId(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };
  const fetchBrickListWithorWithoutFamily = async (id) => {
    try {
      const obj = {
        pageNumber: 0,
        pageSize: 10,
        filterSearch: null,
        active: 0,
        sortDirection: "ASC",
        sortBy: "brickId",
        productFamilyId: id ? id : 0,
      };
      const brickListingResponse = await BrickListingWithOrWithoutFamilyId(obj);
      if (brickListingResponse.statusCode === 6) {
        setBrickList(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };
  const fetchDocTypeList = async () => {
    try {
      const docTypeListingResponse = await docTypeListingService(1);
      if (docTypeListingResponse.statusCode === 6) {
        setDocTypeListing(docTypeListingResponse.data.docParams);
      } else {
        showNotification("Error", docTypeListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };
  const fetchDepartmentsList = async (sortBy, isAsc, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        pageSize: 100,
        pageNumber: 0,
        filterSearch: searchValue ? searchValue : null,
        active: 0,
        sortBy: "name",
        sortDirection: "DESC",
      };
      const response = await departmentsListingService(requestBody);
      if (response.statusCode === 6) {
        setDepartMentList(response.data.content);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
      showNotification("Error", "fail to fetch Departments listing", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchProductFamilyList = async (id) => {
    try {
      const obj = {
        pageNumber: 0,
        pageSize: 10,
        filterSearch: null,
        active: loginUserType === "Main Admin" ? 2 : 0,
        categoryId: id ? id : null,
        sortDirection: "DESC",
        sortBy: "productFamilyName",
      };
      const familyListingResponse = await FamilyListingService(obj);
      if (familyListingResponse.statusCode === 6) {
        setProductFamilyList(familyListingResponse.data);
      } else {
        showNotification("Error", familyListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };
  const fetchServiceAdvisoryDetails = async (
    sortBy,
    isAsc,
    brandSearch_,categorySearch_,familySearch_,brickSearch_,typeSearch_,modelSearchValue_,techDocSearch_,pageSize
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: 0,
        pageSize: pageSize ?? 10,
        sortDirection: isAsc ? "DESC" : "ASC",
        sortBy: sortBy,
        brandId: brandSearch_ ? brandSearch_ : null,
        brickId: brickSearch_ ? brickSearch_ : null,
        name: modelSearchValue_ ? modelSearchValue_.trim() : null,
        productFamilyId: familySearch_? familySearch_:null,
        deptId: auth.ldapParam.deptId,
        userType: auth.ldapParam.userType,
        userId: loginUserId ? loginUserId : null,
        releaseDate: null,
        isDrafted: null,
        docTypeId: typeSearch_? typeSearch_ : null,
        modelName: modelSearchValue_? modelSearchValue_ : null,
        categoryId:categorySearch_ ? categorySearch_ : null,
        advisoryNumber: techDocSearch_ ? techDocSearch_ :null,
      };
   
      const response = await ServiceAdvisoryListService(requestBody);
      if (response.statusCode === 6) {
        if (response.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setTechDocumentRecords(response.data.content);
        setTotalElements(response.data.totalElements);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const UploadServiceAdvisoryDetails = async (file, values) => {
    try {
      setLoading(true);
      const requestBody = {
        modelId: values?.modelId ?? null,
        isDownloadAble: values?.isDownloadAble,
        createdBy: loginUserId,
        releaseDate: values?.releaseDate,
        advisoryNumber: values?.advisoryNumber ?? null,
        notificationDes: values?.notificationDes ?? null,
        sendNotification: values?.sendNotification,
        deptId: values?.deptId,
        isDrafted: values?.isDrafted,
        id: null,
        docTypeId: values?.docTypeId,
        serviceAdvDesc: values?.serviceAdvDesc,
        userDeptId: values?.userDeptId,
      };
      const res = await ServiceAdvisoryUploadService(file, requestBody);
      if (res) {
        return res;
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const UpdateServiceAdvisoryDetails = async (file, values) => {
    try {
      setLoading(true);
      const requestBody = {
        id: values?.id ?? null,
        modifiedBy: loginUserId,
        modelId: values?.modelId ?? null,
        isDownloadAble: values?.isDownloadAble,
        releaseDate: values?.releaseDate,
        advisoryNumber: values?.advisoryNumber ?? null,
        notificationDes: values?.notificationDes ?? null,
        sendNotification: values?.sendNotification,
        deptId: values?.deptId,
        isDrafted: values?.isDrafted,
        docTypeId: values?.docTypeId,
        serviceAdvDesc: values?.serviceAdvDesc,
        oldAdvisoryNumber: values?.oldAdvisoryNumber,
        userDeptId: values?.userDeptId,
      };
      const res = await ServiceAdvisoryUpdatService(file, requestBody);
      if (res) {
        return res;
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };
  const onSearchServiceAdvisoryDetails = async (values) => {
    try {
      setLoading(true);

      const requestBody = {
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortDirection: "DESC",
        sortBy: "advisoryNumber",
        brandId: values?.brandId ?? null,
        brickId: values?.brickId ?? null,
        name: values?.name ?? null,
        deptId: auth.ldapParam.deptId,
        userType: auth.ldapParam.userType,
        userId: loginUserId ? loginUserId : null,
        releaseDate: values?.brandId ?? null,
        isDrafted: values?.isDrafted ?? null,
        docTypeId: values?.docTypeId ?? null,
        modelName: values?.modelName ?? null,
        advisoryNumber: values?.advisoryNumber ?? null,
        categoryId: values?.categoryId ?? null,
        productFamilyId: values?.productFamilyId ?? null,
      };
      const response = await ServiceAdvisoryListOnSearchService(requestBody);

      if (response.statusCode === 6) {
        if (response.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setTechDocumentRecords(response.data.content);
        setTotalElements(response.data.totalElements);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };
  const fetchBrandListOnSelectedBrick = async (id) => {
    try {
      const brandListingResponse = await brandListingOnSelectedBrickService(id);

      if (brandListingResponse.statusCode === 6) {
        setBrandListOnBrickId(brandListingResponse.data);
      } else {
        showNotification("Error", brandListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  
  const loadAllFiles = async (id) => {
    try {
      const responseFiles = await DownloadServiceAdvisoryService(id);
      if (responseFiles.status === 200) {
       
     const uploadedfilesdata = [];

   
     const [, filename] = responseFiles.headers['content-disposition'].split('filename=');
     const withoutFirstAndLast = filename.slice(1, -1);
     //download(responseFiles.data, withoutFirstAndLast, content);
      if(withoutFirstAndLast.includes("zip")){
        const jsZip = new JSZip();
        jsZip.loadAsync(responseFiles.data).then(function (zip) {
          Object.keys(zip.files).forEach(function (filename,index) {
              zip.files[filename].async("blob").then(function (fileData) {
              
                uploadedfilesdata.push(new File([fileData], filename));
              });
          });
        });
      }else{
        var fileObject= responseFiles.data;
        const blobFile = new Blob([fileObject]);
        uploadedfilesdata.push(new File([blobFile], withoutFirstAndLast));
      }
     

      setExistingFiles(uploadedfilesdata);
    
      
      } else {
        setExistingFiles([]);
        showNotification("Error", responseFiles.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };
  
  const fetchBrickListOnSelectedBrand = async (id) => {
    try {
      const brickListingResponse = await brickListingOnSelectedBrandService(id);
      if (brickListingResponse.statusCode === 6) {
        setBrickListOnBrandId(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    brandSearch,
    categorySearch,
    familySearch,
    brickSearch,
    typeSearch,
    modelSearchValue,
    techDocSearch
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        status: 2,
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        sortBy: orderBy,
        sortDirection: sortValue === null ? "DESC" : sortValue,
        brandId: brandSearch ?? null,
        brickId: brickSearch ?? null,
        categoryId: categorySearch ?? null,
        productFamilyId: familySearch ?? null,
        name: null,
        deptId: auth.ldapParam.deptId,
        userType: auth.ldapParam.userType,
        userId: loginUserId ? loginUserId : null,
        releaseDate: null,
        isDrafted: null,
        docTypeId: typeSearch ?? null,
        modelName: modelSearchValue ?? null,
        advisoryNumber: techDocSearch ?? null,
      };
      const response = await ServiceAdvisoryListService(requestBody);

      if (response.statusCode === 6) {
        if (isUpdate) {
          setTechDocumentRecords([
            ...techDocumentRecords,
            ...response.data.content,
          ]);
        } else {
          setTechDocumentRecords(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  const fetchAllBrandsList = async () => {
    try {
      const allBrandsListingResponse = await AllBrandListingService();
      if (allBrandsListingResponse.statusCode === 6) {
        setAllBrands(allBrandsListingResponse.data);
      } else {
        showNotification("Error", allBrandsListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchModelsList = async (brickId, brandId) => {
    try {
      const response = await ModelListingService(brickId, brandId);
      if (response.statusCode === 6) {
        setModelList(response.data.spareModel);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchModelDescriptionOnSelectedModel = async (modelId) => {
    try {
      const response = await ModelDescriptionOnSelectedModelService(modelId);
      if (response.statusCode === 6) {
        setModelDescription(response.data);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchModelsDeptList = async (brickId, brandId, advisoryNumber) => {
    try {
      const response = await ModeDeptListingService(
        brickId,
        brandId,
        advisoryNumber
      );
      if (response.statusCode === 6) {
        setModelList(response?.data?.spareModelResponse?.spareModel);
        let model1 = response?.data?.spareModelResponse?.spareModel.filter(
          (val) => {
            return response?.data?.modelAndDeptDetailsResponse?.modelIds.includes(
              val.modelId
            );
          }
        );
        setModelIdData(model1);
        setSelectedModelIds(model1);

        let test = departmentList.filter((val) => {
          return response?.data?.modelAndDeptDetailsResponse?.deptIds.includes(
            val.departmentId
          );
        });

        setDeptIdData(test);
        setSelectedDeptlIds(test);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
    }
  };

  const fetchBrickListOnSelectedBrandForUpload = async (id) => {
    try {
      const brickListingResponse = await brickListingOnSelectedBrandService(id);
      if (brickListingResponse.statusCode === 6) {
        setBrickListForUpload(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <>
      <ServiceAdvisoryList
        techDocumentRecords={techDocumentRecords}
        handleTableChanges={handleTableChanges}
        brandListOnBrickId={brandListOnBrickId}
        brickListOnBrandId={brickListOnBrandId}
        fetchBrickListOnSelectedBrand={fetchBrickListOnSelectedBrand}
        fetchBrandListOnSelectedBrick={fetchBrandListOnSelectedBrick}
        fetchServiceAdvisoryDetails={fetchServiceAdvisoryDetails}
        onSearchServiceAdvisoryDetails={onSearchServiceAdvisoryDetails}
        totalElements={totalElements}
        setTechDocumentRecords={setTechDocumentRecords}
        setTotalElements={setTotalElements}
        setLoading={setLoading}
        showNotification={showNotification}
        fetchAllBrandsList={fetchAllBrandsList}
        UploadServiceAdvisoryDetails={UploadServiceAdvisoryDetails}
        allBrands={allBrands}
        modelList={modelList}
        fetchModelsList={fetchModelsList}
        fetchModelDescriptionOnSelectedModel={
          fetchModelDescriptionOnSelectedModel
        }
        fetchModelsDeptList={fetchModelsDeptList}
        fetchBrickListOnSelectedBrandForUpload={
          fetchBrickListOnSelectedBrandForUpload
        }
        modelDescription={modelDescription}
        brickListForUpload={brickListForUpload}
        state={state}
        noRecord={noRecord}
        setModelDescription={setModelDescription}
        notificationDetailState={notificationDetailState}
        notificationPageNo={notificationPageNo}
        notificationType={notificationType}
        UpdateServiceAdvisoryDetails={UpdateServiceAdvisoryDetails}
        fetchBrickListWithorWithoutFamily={fetchBrickListWithorWithoutFamily}
        brickList={brickList}
        fetchProductFamilyList={fetchProductFamilyList}
        productFamilyList={productFamilyList}
        fetchCategoryListOnSelectedBrand={fetchCategoryListOnSelectedBrand}
        setCategoryListOnBrandId={setCategoryListOnBrandId}
        categoryListOnBrandId={categoryListOnBrandId}
        fetchDocTypeList={fetchDocTypeList}
        docTypeList={docTypeList}
        departmentList={departmentList}
        brandDropDownList={brandDropDownList}
        fetchBrandSearchDropdownList={fetchBrandSearchDropdownList}
        fetchCatSearchDropdownList={fetchCatSearchDropdownList}
        fetchFamSearchDropdownList={fetchFamSearchDropdownList}
        fetchBrickSearchDropdownList={fetchBrickSearchDropdownList}
        categoryList={categoryList}
        familyList={familyList}
        brickDropdownList={brickDropdownList}
        modelIdData={modelIdData}
        deptIdData={deptIdData}
        selectedModelIds={selectedModelIds}
        selectedDeptIds={selectedDeptIds}
        setSelectedModelIds={setSelectedModelIds}
        setSelectedDeptlIds={setSelectedDeptlIds}
        setModelIdData={setModelIdData}
        setDeptIdData={setDeptIdData}
        loadAllFiles={loadAllFiles}
        existingFiles={existingFiles}
        setExistingFiles={setExistingFiles}
      />
    </>
  );
};
export default ServiceAdvisory;
